import { MatrixEditor, RolesScreen, type SetupStatus, SetupWizard, UsersScreen } from '@felix/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Shell } from '../components/Shell.js';
import { officeSource } from '../personnel-source.js';
import { officeSetupSource } from '../setup-source.js';

/**
 * Şirket kurulumu sayfaları (ADR 0042 §22–§24): Settings altında sayfa içi; menüye öğe eklenmez
 * (ADR 0019, ADR 0042 §21). Breadcrumb "Settings ›" ile başlar.
 */

export function SetupWizardPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('setup.wizard.title')}>
      <SetupWizard source={officeSetupSource} />
    </Shell>
  );
}

export function RolesPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('setup.roles.title')}>
      <RolesScreen source={officeSetupSource} />
    </Shell>
  );
}

export function UsersPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('setup.users.title')}>
      {/* Kartlı kişinin gemi rolü çekmecede Sign On / Off ile (ADR 0155 Ek) */}
      <UsersScreen
        source={officeSetupSource}
        today={new Date().toISOString().slice(0, 10)}
        personnel={officeSource}
      />
    </Shell>
  );
}

const TABS = ['permissions', 'approvals', 'history'] as const;

export function MatricesPage() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const tab = new URLSearchParams(search).get('tab');
  return (
    <Shell title={t('setup.matrix.title')}>
      <MatrixEditor
        key={tab ?? 'permissions'}
        source={officeSetupSource}
        initialTab={TABS.find((name) => name === tab) ?? 'permissions'}
      />
    </Shell>
  );
}

/**
 * Settings kartının durumu: yalnız `settings.edit` yetkisinde okunur (403'te kart çizilmez;
 * ADR 0042 §22).
 */
export function useSetupStatus(): SetupStatus | null {
  const [status, setStatus] = useState<SetupStatus | null>(null);
  useEffect(() => {
    let alive = true;
    officeSetupSource
      .setupStatus()
      .then((value) => {
        if (alive) setStatus(value);
      })
      .catch(() => {
        if (alive) setStatus(null);
      });
    return () => {
      alive = false;
    };
  }, []);
  return status;
}
